import type { GestorDashboardTimeEntry } from '@/components/Gestores/gestorDashboardTypes'

export type GestorDashboardExecutorTaskRow = {
  key: string
  taskId: number | null
  task: string
  effortMinutes: number
  apontamentos: number
  workspace: string | null
}

export function buildExecutorTaskRows(entries: GestorDashboardTimeEntry[]): GestorDashboardExecutorTaskRow[] {
  const map = new Map<string, GestorDashboardExecutorTaskRow>()

  for (const entry of entries) {
    if (!entry.task) continue
    const key = String(entry.taskId ?? entry.task)
    const current = map.get(key) ?? {
      key,
      taskId: entry.taskId ?? null,
      task: entry.task,
      effortMinutes: 0,
      apontamentos: 0,
      workspace: entry.workspace,
    }
    current.effortMinutes += entry.effortMinutes
    current.apontamentos += 1
    if (!current.workspace && entry.workspace) current.workspace = entry.workspace
    map.set(key, current)
  }

  return [...map.values()].sort((a, b) => b.effortMinutes - a.effortMinutes)
}

export function summarizeExecutorEntries(entries: GestorDashboardTimeEntry[]) {
  const productive = entries.filter((entry) => entry.productive)
  return {
    totalEffortMinutes: entries.reduce((sum, entry) => sum + entry.effortMinutes, 0),
    productiveEffortMinutes: productive.reduce((sum, entry) => sum + entry.effortMinutes, 0),
    taskCount: buildExecutorTaskRows(entries).length,
    apontamentos: entries.length,
  }
}
